import { billsTableColumnDefinitions } from '../constants/billsTableColumnDefinitions'
import { BillsTableColumnKey } from '../types/billsTableColumnKey'

interface Params {
  excludedColumnKeys: BillsTableColumnKey[]
}

export const buildBillsTableColumnConfiguration = ({ excludedColumnKeys }: Params) =>
  billsTableColumnDefinitions.filter((column) => !excludedColumnKeys.includes(column.key))
